import { RouterManager } from '@aclass/admin/managers';
import { LeadScoringStory } from '@aclass/admin/storage/actions';
import { IAdminState, ILeadScoringState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class LeadScoringSearchStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:lead-scoring-search';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<ILeadScoringState['searchPageInitialized']>(['leadScoringModule', 'searchPageInitialized']).pipe(
            filter(v => v)
        );
        this.employee = this.routerManager.onRejectNavigation(LeadScoringSearchStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(): void {
        this.ngRdx.dispatch(LeadScoringStory.dryRunSearchPage());
    }
}
